import { CreateInvoiceItemDto } from "../../types/invoice.types";


type GstOption = {
  label: string;
  value: number;
};

export type GstResult = {
  itemName: string;
  gstLabel: string | undefined;
  gstPercentage: number;
  taxAmount: number;
};

export function calculateGstLabelsAndTax(items: CreateInvoiceItemDto[], gstOptions: GstOption[]): GstResult[] {
  return items?.map(item => {
    const gstMatch = gstOptions.find(
      opt => Number(opt.value) === Number(item.sac_gst_rate)
    );


    const taxAmount = ((item.quantity || 0) * (item.unit_price || 0) * (item.sac_gst_rate || 0)) / 100;

    return {
      itemName: item.item_name,
      gstLabel: gstMatch?.label || undefined,
      gstPercentage: item.sac_gst_rate,
      taxAmount: Number(taxAmount.toFixed(2)),
    };
  });
}